import { render, staticRenderFns } from "./customPhoneNumberInput.vue?vue&type=template&id=638e7e70&scoped=true&"
import script from "./customPhoneNumberInput.vue?vue&type=script&lang=js&"
export * from "./customPhoneNumberInput.vue?vue&type=script&lang=js&"
import style0 from "./customPhoneNumberInput.vue?vue&type=style&index=0&id=638e7e70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638e7e70",
  null
  
)

export default component.exports